import "bootstrap/js/dist/collapse.js";
import "bootstrap/js/dist/dropdown.js";

import { startLijuCopyButtons } from "./liju-copy.js";

/**
 * The script every page loads.
 *
 * **Two Bootstrap components, not the bundle.** The navbar toggle and the tools
 * menu are the only things on this site that Bootstrap's JavaScript does, and
 * they used to arrive as `bootstrap.bundle.min.js` from jsDelivr: eighty
 * kilobytes of modals, tooltips and carousels, from a third origin that every
 * page had to resolve, for two of them. Importing the components on their own
 * brings a fraction of that, and it comes from the same place as everything else
 * here.
 *
 * The dropdown is the expensive one, because it is what pulls in Popper to
 * position the menu. The collapse costs almost nothing beside it.
 *
 * Both imports are for their effect rather than for anything they export.
 * Bootstrap's individual distribution files each register their own data API, so
 * pulling them in is what makes `data-bs-toggle="collapse"` and
 * `data-bs-toggle="dropdown"` work; there is nothing to call.
 *
 * **The 例句 copy buttons.** The one piece of this site's own behaviour in here,
 * and it is here rather than in a bundle of its own because it is a few hundred
 * bytes: a second request on the sentence pages would cost more than carrying it
 * everywhere does. It finds nothing to do on the other thousand pages.
 *
 * No `DOMContentLoaded` around it. The tag in `page-sections/header-start.html`
 * is `type="module"`, which defers, so the document is parsed by the time this
 * runs.
 */
startLijuCopyButtons(document);
